import { render } from "./editSupport.vue?vue&type=template&id=0ca2c82e&scoped=true"
import script from "./editSupport.vue?vue&type=script&lang=js"
export * from "./editSupport.vue?vue&type=script&lang=js"

import "./editSupport.vue?vue&type=style&index=0&id=0ca2c82e&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca2c82e"]])

export default __exports__